import {
  ROUTE_CHANGE,
  RATE_MY_DELIVERY_MODAL_CHANGE,
  RATE_MY_DELIVERY_RATED,
} from '../../constants/ratings'
import { IRatingsState } from '../../interfaces/ratings'

export const initialState: IRatingsState = {
  rateMyDelivery: {
    comment: '',
    isShowing: false,
    score: 0,
    skipped: false,
    answers: [{ questionId: '', responses: [] }],
    modalStatus: 'initial',
    survey: {},
    submittedMessage: '',
    mandatoryComment: false,
    showVendorName: false,
  },
  rated: [],
}

const ratingsReducer = (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case RATE_MY_DELIVERY_MODAL_CHANGE:
      return {
        ...state,
        rateMyDelivery: {
          ...state.rateMyDelivery,
          ...payload,
        },
      }
    case RATE_MY_DELIVERY_RATED:
      return {
        ...state,
        rated: [...state.rated, payload.orderNumber],
      }
    case ROUTE_CHANGE:
      return initialState
    default:
      return state
  }
}

export default ratingsReducer
